import React, { Component } from "react";
import { ErrorMessage, PageMode, requestStatus } from "utils/constant";
import { toast } from "react-toastify";
import { ArrowLeft } from "react-feather";
import InputDateTime from "components/InputDateTime";
import moment from "moment";
import { Button, InputField, InputSelect } from "components";
import IRSResult from "services/IRSResult";
import Wilayah from "services/Wilayah";
import InputCheckbox from "components/InputCheckbox";
import Populasi from "services/Populasi";
import KelambuDistribution from "services/KelambuDistribution";

const IRSResultService = new IRSResult();
const WilayahService = new Wilayah();
const PopulationService = new Populasi();
const DistribusiKelambuService = new KelambuDistribution();

const KELAMBU_TYPES = [
  "Kelambu Massal Total",
  "Kelambu Massal Fokus",
  "Kelambu PE 1-2-5",
  "Kelambu KLB/Bencana",
  "Kelambu Massak Fokus",
];

const VECTOR_CONTROL_TABS = [
  {
    key: "Kelambu Massal Total",
    label: "Kelambu Massal Total",
    type: "kelambu",
  },
  {
    key: "Kelambu Massal Fokus",
    label: "Kelambu Massal Fokus",
    type: "kelambu",
  },
  { key: "Kelambu PE 1-2-5", label: "Kelambu PE 1-2-5", type: "kelambu" },
  { key: "Kelambu KLB/Bencana", label: "Kelambu KLB/Bencana", type: "kelambu" },
  { key: "IRS", label: "IRS", type: "irs" },
];

const isKelambuSelected = (arr) => arr?.some((v) => KELAMBU_TYPES.includes(v));

export default class FormComponent extends Component {
  _isMounted = true;

  constructor(props) {
    super(props);
    this.defaultValue = {
      fasyankes_id: {
        value: this.props.currentUser.fasyankes_id,
        isValid: true,
        message: "",
      },

      province_id: {
        value: this.props.currentUser.province_id,
        isValid: true,
        message: "",
      },
      district_id: {
        value: this.props.currentUser.district_id,
        isValid: true,
        message: "",
      },
      subdistrict_id: {
        value: this.props.currentUser.subdistrict_id,
        isValid: true,
        message: "",
      },
      urbanvillage_id: { value: "", isValid: true, message: "" },
      total_population_urbanvillage: { value: "", isValid: true, message: "" },

      vector_controll_type: { value: "", isValid: true, message: "" },

      irs_date: { value: "", isValid: true, message: "" },
      insecticide_type: { value: "", isValid: true, message: "" },
      total_insecticide: { value: "", isValid: true, message: "" },
      total_insecticide_unit: { value: "", isValid: true, message: "" },
      total_targeted_house: { value: "", isValid: true, message: "" },
      total_sprayed_house: { value: "", isValid: true, message: "" },
      is_dusun_level_intervention: { value: "", isValid: true, message: "" },

      net_distribution_date: { value: "", isValid: true, message: "" },
      total_mosquito_nets_received: { value: "", isValid: true, message: "" },
      total_net_distribution: { value: "", isValid: true, message: "" },
      total_net_distribution_sub_village: {
        value: "",
        isValid: true,
        message: "",
      },
      total_mosquito_desk: { value: "", isValid: true, message: "" },
      total_population_target: { value: "", isValid: true, message: "" },
      is_dusun_level_distribution: { value: "", isValid: true, message: "" },

      total_sub_villages: { value: "", isValid: true, message: "" },

      hamlets_distribution: { value: [], isValid: true, message: "" },
      hamlets_irs: { value: [], isValid: true, message: "" },

      urbanvillages: [],

      // Active tab for vector control type
      activeTab: VECTOR_CONTROL_TABS[0].key,

      sub_village: { value: "", isValid: true, message: "" },
      total_population_sub_village: { value: "", isValid: true, message: "" },

      total_target_houses_hamlet_level: {
        value: "",
        isValid: true,
        message: "",
      },
      total_houses_sprayed_at_hamlet_level: {
        value: "",
        isValid: true,
        message: "",
      },

      isLoading: false,
    };
    this.state = Object.assign({}, this.defaultValue);
  }

  componentDidMount() {
    this._isMounted = true;
    this.getUrbanvillagesByCurrentUser();

    let obj = Object.assign({}, this.state);

    if (this.props.mode === PageMode.edit) {
      const { data } = this.props;

      obj.province_id.value = data.province_id ?? "";
      obj.district_id.value = data.district_id ?? "";
      obj.subdistrict_id.value = data.subdistrict_id ?? "";
      obj.fasyankes_id.value = data.fasyankes_id ?? "";
      obj.urbanvillage_id.value = data.urbanvillage_id ?? "";
      obj.total_population_urbanvillage.value =
        data.total_population_urbanvillage ?? "";

      obj.vector_controll_type.value = Array.isArray(data.vector_controll_type)
        ? data.vector_controll_type[0] || ""
        : data.vector_controll_type || "";

      // Set activeTab based on the vector control type in edit mode
      if (obj.vector_controll_type.value) {
        obj.activeTab = obj.vector_controll_type.value;
      }

      obj.irs_date.value = data.irs_date ?? "";
      obj.insecticide_type.value = data.insecticide_type ?? "";
      obj.total_insecticide.value = data.total_insecticide ?? "";
      obj.total_insecticide_unit.value = data.total_insecticide_unit ?? "";
      obj.total_targeted_house.value = data.total_targeted_house ?? "";
      obj.total_sprayed_house.value = data.total_sprayed_house ?? "";

      obj.net_distribution_date.value = data.net_distribution_date ?? "";
      obj.total_mosquito_nets_received.value =
        data.total_mosquito_nets_received ?? "";
      obj.total_net_distribution.value = data.total_net_distribution ?? "";
      obj.total_net_distribution_sub_village.value =
        data.total_net_distribution_sub_village ?? "";
      obj.total_mosquito_desk.value = data.total_mosquito_desk ?? "";
      obj.total_population_target.value = data.total_population_target ?? "";

      obj.is_dusun_level_distribution.value =
        data.is_dusun_level_distribution ?? "";
      obj.is_dusun_level_intervention.value =
        data.is_dusun_level_intervention ?? "";
      obj.total_sub_villages.value = data.total_sub_villages ?? "";

      obj.hamlets_distribution.value = Array.isArray(data.hamlets_distribution)
        ? data.hamlets_distribution
        : [];
      obj.hamlets_irs.value = Array.isArray(data.hamlets_irs)
        ? data.hamlets_irs
        : [];

      obj.sub_village.value = data.sub_village ?? "";
      obj.total_population_sub_village.value =
        data.total_population_sub_village ?? "";
      obj.total_target_houses_hamlet_level.value =
        data.total_target_houses_hamlet_level ?? "";
      obj.total_houses_sprayed_at_hamlet_level.value =
        data.total_houses_sprayed_at_hamlet_level ?? "";

      this.getTotalKelambuDesk(
        obj.urbanvillage_id.value,
        new Date().getFullYear(),
      );
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getUrbanvillagesByCurrentUser = async () => {
    const { currentUser } = this.props;

    try {
      const res = await PopulationService.getAll({
        page: 1,
        limit: 9999,
        searchBy: `fasyankes_id,year`,
        searchValue: `${currentUser.fasyankes_id},${new Date().getFullYear()}`,
      });

      this.setState({
        urbanvillages: res.populations || [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState(
      {
        [name]: { value, isValid: true, message: "" },
      },
      () => {
        if (name === "total_sub_villages") {
          const n = parseInt(value || "0", 10);
          this.syncHamletRows(
            isNaN(n) ? 0 : n,
            this.state.is_dusun_level_distribution.value === "Ya",
            this.state.is_dusun_level_intervention.value === "Ya",
          );
        }

        if (name === "is_dusun_level_distribution" && value === "Tidak") {
          this.setState({
            hamlets_distribution: { value: [], isValid: true, message: "" },
            ...(this.state.is_dusun_level_intervention.value !== "Ya" && {
              total_sub_villages: { value: "", isValid: true, message: "" },
            }),
          });
        }
        if (name === "is_dusun_level_intervention" && value === "Tidak") {
          this.setState({
            hamlets_irs: { value: [], isValid: true, message: "" },
            ...(this.state.is_dusun_level_distribution.value !== "Ya" && {
              total_sub_villages: { value: "", isValid: true, message: "" },
            }),
          });
        }

        if (name === "urbanvillage_id") {
          this.getTotalKelambuDesk(value, new Date().getFullYear());

          const found = this.state.urbanvillages?.find(
            (item) => String(item.urbanvillage_id) === String(value),
          );
          this.setState({
            total_population_urbanvillage: {
              value: found?.total_population ?? "",
              isValid: true,
              message: "",
            },
          });
        }
      },
    );
  };

  getTotalKelambuDesk = async (urbanvillage_id, year) => {
    await DistribusiKelambuService.totalDesk(urbanvillage_id, year)
      .then((res) => {
        this.setState({
          total_mosquito_desk: {
            value: res.total_kelambu_desk,
            isValid: true,
            message: "",
          },
        });
        this.setState({
          total_population_target: {
            value: res.total_target_population,
            isValid: true,
            message: "",
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleTabChange = (tabKey) => {
    this.setState(
      {
        activeTab: tabKey,
        vector_controll_type: { value: tabKey, isValid: true, message: "" },
      },
      () => {
        // Load desk data for Kelambu types
        if (
          KELAMBU_TYPES.includes(tabKey) &&
          this.state.urbanvillage_id.value
        ) {
          this.getTotalKelambuDesk(
            this.state.urbanvillage_id.value,
            new Date().getFullYear(),
          );
        }
      },
    );
  };

  syncHamletRows = (n, enableKelambu, enableIRS) => {
    if (enableKelambu) {
      const arr = [...this.state.hamlets_distribution.value];
      while (arr.length < n)
        arr.push({
          nama_dusun: "",
          jumlah_penduduk_dusun: "",
          jumlah_kelambu_terdistribusi_tingkat_dusun: "",
        });
      if (arr.length > n) arr.length = n;
      this.setState({
        hamlets_distribution: { value: arr, isValid: true, message: "" },
      });
    }

    if (enableIRS) {
      const arr2 = [...this.state.hamlets_irs.value];
      while (arr2.length < n)
        arr2.push({
          nama_dusun: "",
          jumlah_penduduk_dusun: "",
          jumlah_total_sasaran_rumah_tingkat_dusun: "",
          jumlah_total_rumah_yang_disemprot_tingkat_dusun: "",
        });
      if (arr2.length > n) arr2.length = n;
      this.setState({
        hamlets_irs: { value: arr2, isValid: true, message: "" },
      });
    }
  };

  handleHamletDistributionChange = (index, field, value) => {
    const arr = [...this.state.hamlets_distribution.value];
    arr[index] = { ...arr[index], [field]: value };
    this.setState({
      hamlets_distribution: { value: arr, isValid: true, message: "" },
    });
  };

  handleHamletIRSChange = (index, field, value) => {
    const arr = [...this.state.hamlets_irs.value];
    arr[index] = { ...arr[index], [field]: value };
    this.setState({ hamlets_irs: { value: arr, isValid: true, message: "" } });
  };

  nullConverter = (value) => (value === "" ? null : value);

  buildBasePayload = () => {
    const s = this.state;
    return {
      province_id: this.nullConverter(s.province_id.value),
      district_id: this.nullConverter(s.district_id.value),
      subdistrict_id: this.nullConverter(s.subdistrict_id.value),
      fasyankes_id: this.nullConverter(s.fasyankes_id.value),
      urbanvillage_id: this.nullConverter(s.urbanvillage_id.value),
      total_population_urbanvillage: this.nullConverter(
        s.total_population_urbanvillage.value,
      ),
      vector_controll_type: s.activeTab,

      irs_date: this.nullConverter(s.irs_date.value),
      insecticide_type: this.nullConverter(s.insecticide_type.value),
      total_insecticide: this.nullConverter(s.total_insecticide.value),
      total_insecticide_unit: this.nullConverter(
        s.total_insecticide_unit.value,
      ),
      total_targeted_house: this.nullConverter(s.total_targeted_house.value),
      total_sprayed_house: this.nullConverter(s.total_sprayed_house.value),
      is_dusun_level_intervention: this.nullConverter(
        s.is_dusun_level_intervention.value,
      ),

      net_distribution_date: this.nullConverter(s.net_distribution_date.value),
      total_mosquito_nets_received: this.nullConverter(
        s.total_mosquito_nets_received.value,
      ),
      total_net_distribution: this.nullConverter(
        s.total_net_distribution.value,
      ),
      total_net_distribution_sub_village: this.nullConverter(
        s.total_net_distribution_sub_village.value,
      ),
      total_mosquito_desk: this.nullConverter(s.total_mosquito_desk.value),
      total_population_target: this.nullConverter(
        s.total_population_target.value,
      ),
      is_dusun_level_distribution: this.nullConverter(
        s.is_dusun_level_distribution.value,
      ),

      total_sub_villages: this.nullConverter(s.total_sub_villages.value),

      sub_village: this.nullConverter(s.sub_village.value),
      total_population_sub_village: this.nullConverter(
        s.total_population_sub_village.value,
      ),
      total_target_houses_hamlet_level: this.nullConverter(
        s.total_target_houses_hamlet_level.value,
      ),
      total_houses_sprayed_at_hamlet_level: this.nullConverter(
        s.total_houses_sprayed_at_hamlet_level.value,
      ),
    };
  };

  onSave = async (e) => {
    e.preventDefault();
    const isValid = this._validationHandler();
    if (!isValid) return;

    const s = this.state;
    const base = this.buildBasePayload();

    const kelambuRows =
      KELAMBU_TYPES.includes(s.activeTab) &&
      s.is_dusun_level_distribution.value === "Ya"
        ? (s.hamlets_distribution.value || []).filter(
            (r) =>
              r?.nama_dusun ||
              r?.jumlah_penduduk_dusun ||
              r?.jumlah_kelambu_terdistribusi_tingkat_dusun,
          )
        : [];

    const irsRows =
      s.activeTab === "IRS" && s.is_dusun_level_intervention.value === "Ya"
        ? (s.hamlets_irs.value || []).filter(
            (r) =>
              r?.nama_dusun ||
              r?.jumlah_penduduk_dusun ||
              r?.jumlah_total_sasaran_rumah_tingkat_dusun ||
              r?.jumlah_total_rumah_yang_disemprot_tingkat_dusun,
          )
        : [];

    this.setState({ isLoading: true });

    try {
      if (
        this.props.mode === PageMode.add &&
        (kelambuRows.length > 0 || irsRows.length > 0)
      ) {
        let ok = 0;
        let fail = 0;

        for (const row of kelambuRows) {
          const payloadRow = {
            ...base,
            sub_village: this.nullConverter(row.nama_dusun),
            total_population_sub_village: this.nullConverter(
              row.jumlah_penduduk_dusun,
            ),
            total_net_distribution_sub_village: this.nullConverter(
              row.jumlah_kelambu_terdistribusi_tingkat_dusun,
            ),
          };
          try {
            await IRSResultService.add(payloadRow);
            ok++;
          } catch (err) {
            fail++;
          }
        }

        for (const row of irsRows) {
          const payloadRow = {
            ...base,
            sub_village: this.nullConverter(row.nama_dusun),
            total_population_sub_village: this.nullConverter(
              row.jumlah_penduduk_dusun,
            ),
            total_target_houses_hamlet_level: this.nullConverter(
              row.jumlah_total_sasaran_rumah_tingkat_dusun,
            ),
            total_houses_sprayed_at_hamlet_level: this.nullConverter(
              row.jumlah_total_rumah_yang_disemprot_tingkat_dusun,
            ),
          };
          try {
            await IRSResultService.add(payloadRow);
            ok++;
          } catch (err) {
            fail++;
          }
        }

        this.setState({ isLoading: false });

        if (ok > 0) {
          toast.success(`Berhasil submit ${ok} data.`, {
            position: "top-right",
          });
        }
        if (fail > 0) {
          toast.error(`Gagal submit ${fail} data.`, { position: "top-right" });
        }

        this.setState(this.defaultValue, () => {
          this.props.changeMode("view");
        });
      } else {
        if (this.props.mode === PageMode.add) {
          await IRSResultService.add(base);
          toast.success("Data Berhasil Ditambahkan!", {
            position: "top-right",
          });
        } else {
          await IRSResultService.update(base, this.props.data.id);
          toast.success("Data Berhasil Diubah!", { position: "top-right" });
        }

        this.setState(this.defaultValue, () => {
          this.props.changeMode("view");
        });
      }
    } catch (err) {
      console.log(err);
      const status = err?.response?.status;
      this.setState({ isLoading: false });

      if (status === requestStatus.BadRequest) {
        toast.error(ErrorMessage.UserFaskesNotHaveAccess);
      } else if (status === requestStatus.Forbidden) {
        toast.error(ErrorMessage.UserNotVerified);
      } else if (status === requestStatus.Conflict) {
        toast.error(ErrorMessage.DataAlreadyExist);
      } else if (status === requestStatus.ServerError) {
        toast.error(ErrorMessage.InternalServerError);
      } else {
        toast.error("Gagal menyimpan data");
      }
    }
  };

  _validationHandler = () => {
    const s = this.state;
    let isValid = true;
    const markInvalid = (key, message) => {
      this.setState({ [key]: { ...s[key], isValid: false, message } });
      isValid = false;
    };

    if (s.urbanvillage_id.value == null || s.urbanvillage_id.value === "") {
      markInvalid("urbanvillage_id", "Kelurahan tidak boleh kosong");
    }

    if (s.activeTab === "IRS") {
      if (s.irs_date.value == null || s.irs_date.value === "") {
        markInvalid("irs_date", "Tanggal IRS tidak boleh kosong");
      }
      if (s.insecticide_type.value == null || s.insecticide_type.value === "") {
        markInvalid("insecticide_type", "Jenis Insektisida tidak boleh kosong");
      }
      if (
        s.total_insecticide.value == null ||
        s.total_insecticide.value === ""
      ) {
        markInvalid(
          "total_insecticide",
          "Jumlah Insektisida yang digunakan tidak boleh kosong",
        );
      }
      if (
        s.total_insecticide_unit.value == null ||
        s.total_insecticide_unit.value === ""
      ) {
        markInvalid(
          "total_insecticide_unit",
          "Satuan insektisida tidak boleh kosong",
        );
      }

      if (this.props.mode === PageMode.add) {
        if (s.is_dusun_level_intervention.value === "Ya") {
          const n = parseInt(s.total_sub_villages.value || "0", 10);
          if (!n || n <= 0) {
            markInvalid(
              "total_sub_villages",
              "Jumlah dusun harus lebih dari 0",
            );
          }
          s.hamlets_irs.value.forEach((row) => {
            if (!row.nama_dusun) isValid = false;
            if (
              row.jumlah_penduduk_dusun == null ||
              row.jumlah_penduduk_dusun === ""
            )
              isValid = false;
            if (
              row.jumlah_total_sasaran_rumah_tingkat_dusun == null ||
              row.jumlah_total_sasaran_rumah_tingkat_dusun === ""
            )
              isValid = false;
            if (
              row.jumlah_total_rumah_yang_disemprot_tingkat_dusun == null ||
              row.jumlah_total_rumah_yang_disemprot_tingkat_dusun === ""
            )
              isValid = false;
          });
        }
      }
    }

    if (KELAMBU_TYPES.includes(s.activeTab)) {
      if (
        s.net_distribution_date.value == null ||
        s.net_distribution_date.value === ""
      ) {
        markInvalid(
          "net_distribution_date",
          "Tanggal Distribusi Kelambu tidak boleh kosong",
        );
      }
      if (
        s.total_mosquito_nets_received.value == null ||
        s.total_mosquito_nets_received.value === ""
      ) {
        markInvalid(
          "total_mosquito_nets_received",
          "Jumlah kelambu yang diterima desa tidak boleh kosong",
        );
      }
      if (
        s.total_net_distribution.value == null ||
        s.total_net_distribution.value === ""
      ) {
        markInvalid(
          "total_net_distribution",
          "Jumlah kelambu yang dibagikan tidak boleh kosong",
        );
      }

      if (s.is_dusun_level_distribution.value === "Ya") {
        if (this.props.mode === PageMode.add) {
          const n = parseInt(s.total_sub_villages.value || "0", 10);
          if (!n || n <= 0) {
            markInvalid(
              "total_sub_villages",
              "Jumlah dusun harus lebih dari 0",
            );
          }
          s.hamlets_distribution.value.forEach((row) => {
            if (!row.nama_dusun) isValid = false;
            if (
              row.jumlah_penduduk_dusun == null ||
              row.jumlah_penduduk_dusun === ""
            )
              isValid = false;
            if (
              row.jumlah_kelambu_terdistribusi_tingkat_dusun == null ||
              row.jumlah_kelambu_terdistribusi_tingkat_dusun === ""
            )
              isValid = false;
          });
        }
      }
    }

    return isValid;
  };

  _mapper = (e) => {
    const options = [];
    e.forEach((x) => {
      options.push({ value: `${x.id}|${x.name}`, label: x.name });
    });
    return options;
  };

  render() {
    const activeTabType = VECTOR_CONTROL_TABS.find(
      (tab) => tab.key === this.state.activeTab,
    )?.type;
    const showIRS = activeTabType === "irs";
    const showKelambu = activeTabType === "kelambu";

    const showAnyDusunFlag =
      this.state.is_dusun_level_distribution.value === "Ya" ||
      this.state.is_dusun_level_intervention.value === "Ya";

    const hasKelambuMassalTotal =
      this.state.activeTab === "Kelambu Massal Total";
    const hasKelambuMassalFokus =
      this.state.activeTab === "Kelambu Massal Fokus";

    const allowDeskField = hasKelambuMassalTotal || hasKelambuMassalFokus;

    return (
      <div className="dashboard-wrapper">
        <div className="container">
          {this.props.mode !== PageMode.view && (
            <div
              className="my-3"
              style={{ cursor: "pointer" }}
              onClick={() => this.props.changeMode(PageMode.view)}
            >
              <ArrowLeft />
              <span>Kembali</span>
            </div>
          )}

          <h1 className="title font-weight-bold" style={{ padding: "10px" }}>
            Form Laporan Hasil Pengendalian Vektor
          </h1>

          <p className="font-weight-bold" style={{ padding: "0 10px" }}>
            NOTE: <span className="text-danger">*(WAJIB DIISI)</span>
          </p>

          <div className="form-wrapper">
            <InputSelect
              label={"Nama Desa"}
              name="urbanvillage_id"
              placeholder="--PILIH--"
              data={this.state.urbanvillages?.map((x) => ({
                value: `${x.urbanvillage_id}`,
                label:
                  x.urbanvillage_id?.split?.("|")?.[1] ||
                  x.urbanvillage_name ||
                  `${x.urbanvillage_id}`,
              }))}
              value={this.state.urbanvillage_id.value}
              onChange={this.handleInputChange}
              isRequired={true}
              hasError={!this.state.urbanvillage_id.isValid}
              errorMessage={this.state.urbanvillage_id.message}
            />

            <InputField
              label={"Jumlah Penduduk Desa"}
              name="total_population_urbanvillage"
              type={"numberOnly"}
              placeholder="0"
              isDisabled={true}
              onChange={this.handleInputChange}
              value={this.state.total_population_urbanvillage.value}
            />

            <div className="form-group">
              <label className="mb-3">
                Jenis Pengendalian Vektor <sup className="text-danger">*</sup>
              </label>

              {/* Bootstrap Tabs */}
              <ul
                className="nav nav-tabs"
                id="vectorControlTabs"
                role="tablist"
              >
                {VECTOR_CONTROL_TABS.map((tab) => (
                  <li className="nav-item" role="presentation" key={tab.key}>
                    <button
                      className={`nav-link ${
                        this.state.activeTab === tab.key ? "active" : ""
                      }`}
                      id={`${tab.key.replace(/\s+/g, "")}-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#${tab.key.replace(/\s+/g, "")}`}
                      type="button"
                      role="tab"
                      aria-controls={tab.key.replace(/\s+/g, "")}
                      aria-selected={this.state.activeTab === tab.key}
                      onClick={() => this.handleTabChange(tab.key)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {showIRS && (
              <>
                <InputDateTime
                  label={"Tanggal IRS"}
                  name="irs_date"
                  dateFormat={"YYYY-MM-DD"}
                  placeholder="YYYY-MM-DD"
                  value={this.state.irs_date.value}
                  onChange={(e) =>
                    this.handleInputChange({
                      target: {
                        name: "irs_date",
                        isValid: true,
                        value: moment(e).format("YYYY-MM-DD"),
                      },
                    })
                  }
                  isRequired={true}
                  hasError={!this.state.irs_date.isValid}
                  errorMessage={this.state.irs_date.message}
                />
                <InputSelect
                  label={"Jenis Insektisida"}
                  name={"insecticide_type"}
                  placeholder="--PILIH--"
                  data={[
                    { label: "Organophosphate", value: "Organophosphate" },
                    { label: "Karbamat", value: "Karbamat" },
                    { label: "Piretroid", value: "Piretroid" },
                    { label: "Neonikotinoid", value: "Neonikotinoid" },
                  ]}
                  onChange={this.handleInputChange}
                  value={this.state.insecticide_type.value}
                  isRequired={true}
                  hasError={!this.state.insecticide_type.isValid}
                  errorMessage={this.state.insecticide_type.message}
                />
                <div className="row">
                  <div className="col-6">
                    <InputField
                      label={"Jumlah Insektisida yang digunakan"}
                      type={"numberOnly"}
                      placeholder="0"
                      name="total_insecticide"
                      onChange={this.handleInputChange}
                      value={this.state.total_insecticide.value}
                      isRequired={true}
                      hasError={!this.state.total_insecticide.isValid}
                      errorMessage={this.state.total_insecticide.message}
                    />
                  </div>
                  <div className="col-6">
                    <InputSelect
                      label={"Satuan"}
                      name={"total_insecticide_unit"}
                      placeholder="--PILIH--"
                      data={[
                        { label: "Kg", value: "Kg" },
                        { label: "Liter", value: "Liter" },
                      ]}
                      onChange={this.handleInputChange}
                      value={this.state.total_insecticide_unit.value}
                      isRequired={true}
                      hasError={!this.state.total_insecticide_unit.isValid}
                      errorMessage={this.state.total_insecticide_unit.message}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <InputField
                      label={"Jumlah Total Sasaran Rumah"}
                      type={"numberOnly"}
                      placeholder="0"
                      name="total_targeted_house"
                      onChange={this.handleInputChange}
                      value={this.state.total_targeted_house.value}
                      isRequired={true}
                      hasError={!this.state.total_targeted_house.isValid}
                      errorMessage={this.state.total_targeted_house.message}
                    />
                  </div>
                  <div className="col-6">
                    <InputField
                      label={"Jumlah Total Rumah yang disemprot"}
                      type={"numberOnly"}
                      placeholder="0"
                      name="total_sprayed_house"
                      onChange={this.handleInputChange}
                      value={this.state.total_sprayed_house.value}
                      isRequired={true}
                      hasError={!this.state.total_sprayed_house.isValid}
                      errorMessage={this.state.total_sprayed_house.message}
                    />
                  </div>
                </div>

                <InputSelect
                  label={
                    "Apakah ingin menginformasikan intervensi sampai tingkat dusun? (Opsional)"
                  }
                  name={"is_dusun_level_intervention"}
                  placeholder="--PILIH--"
                  data={[
                    { label: "Ya", value: "Ya" },
                    { label: "Tidak", value: "Tidak" },
                  ]}
                  onChange={this.handleInputChange}
                  value={this.state.is_dusun_level_intervention.value}
                  isRequired={false}
                  hasError={!this.state.is_dusun_level_intervention.isValid}
                  errorMessage={this.state.is_dusun_level_intervention.message}
                />

                {this.state.is_dusun_level_intervention.value === "Ya" &&
                  this.props.mode === PageMode.edit && (
                    <div className="row">
                      <div className="col-md-3">
                        <InputField
                          label={"Nama Dusun"}
                          placeholder="Masukkan Nama Dusun"
                          name="sub_village"
                          onChange={this.handleInputChange}
                          value={this.state.sub_village.value}
                          isRequired={true}
                          hasError={!this.state.sub_village.isValid}
                          errorMessage={this.state.sub_village.message}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label={"Jumlah Penduduk Dusun"}
                          placeholder="Masukkan Nama Dusun"
                          name="total_population_sub_village"
                          onChange={this.handleInputChange}
                          value={this.state.total_population_sub_village.value}
                          isRequired={true}
                          hasError={
                            !this.state.total_population_sub_village.isValid
                          }
                          errorMessage={
                            this.state.total_population_sub_village.message
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label={"Jumlah Total Sasaran Rumah (Dusun)"}
                          placeholder="Masukkan total sasaran rumah"
                          name="total_target_houses_hamlet_level"
                          onChange={this.handleInputChange}
                          value={
                            this.state.total_target_houses_hamlet_level.value
                          }
                          isRequired={true}
                          hasError={
                            !this.state.total_target_houses_hamlet_level.isValid
                          }
                          errorMessage={
                            this.state.total_target_houses_hamlet_level.message
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label={"Jumlah Total Rumah yang Disemprot (Dusun)"}
                          placeholder="Masukkan jumlah total rumah"
                          name="total_houses_sprayed_at_hamlet_level"
                          onChange={this.handleInputChange}
                          value={
                            this.state.total_houses_sprayed_at_hamlet_level
                              .value
                          }
                          isRequired={true}
                          hasError={
                            !this.state.total_houses_sprayed_at_hamlet_level
                              .isValid
                          }
                          errorMessage={
                            this.state.total_houses_sprayed_at_hamlet_level
                              .message
                          }
                        />
                      </div>
                    </div>
                  )}
              </>
            )}

            {showKelambu && (
              <>
                <InputDateTime
                  label={"Tanggal Distribusi Kelambu"}
                  name="net_distribution_date"
                  dateFormat={"YYYY-MM-DD"}
                  placeholder="YYYY-MM-DD"
                  value={this.state.net_distribution_date.value}
                  onChange={(e) =>
                    this.handleInputChange({
                      target: {
                        name: "net_distribution_date",
                        isValid: true,
                        value: moment(e).format("YYYY-MM-DD"),
                      },
                    })
                  }
                  isRequired={true}
                  hasError={!this.state.net_distribution_date.isValid}
                  errorMessage={this.state.net_distribution_date.message}
                />

                {allowDeskField && (
                  <InputField
                    label={"Jumlah Kelambu Hasil Desk"}
                    type="numberOnly"
                    placeholder="Auto"
                    isDisabled={true}
                    name="total_mosquito_desk"
                    onChange={this.handleInputChange}
                    value={this.state.total_mosquito_desk.value}
                    isRequired={false}
                    hasError={false}
                    errorMessage=""
                  />
                )}

                <InputField
                  label={"Jumlah kelambu yang diterima desa"}
                  type="numberOnly"
                  placeholder="0"
                  name="total_mosquito_nets_received"
                  onChange={this.handleInputChange}
                  value={this.state.total_mosquito_nets_received.value}
                  isRequired={true}
                  hasError={!this.state.total_mosquito_nets_received.isValid}
                  errorMessage={this.state.total_mosquito_nets_received.message}
                />

                <InputField
                  label={"Jumlah Kelambu Terdistribusi "}
                  type="numberOnly"
                  placeholder="0"
                  name="total_net_distribution"
                  onChange={this.handleInputChange}
                  value={this.state.total_net_distribution.value}
                  isRequired={true}
                  hasError={!this.state.total_net_distribution.isValid}
                  errorMessage={this.state.total_net_distribution.message}
                />

                <InputSelect
                  label={
                    "Apakah ingin menginformasikan distribusi kelambu sampai tingkat dusun? (Opsional)"
                  }
                  name={"is_dusun_level_distribution"}
                  placeholder="--PILIH--"
                  data={[
                    { label: "Ya", value: "Ya" },
                    { label: "Tidak", value: "Tidak" },
                  ]}
                  onChange={this.handleInputChange}
                  value={this.state.is_dusun_level_distribution.value}
                  hasError={!this.state.is_dusun_level_distribution.isValid}
                  errorMessage={this.state.is_dusun_level_distribution.message}
                />
                {this.state.is_dusun_level_distribution.value === "Ya" &&
                  this.props.mode === PageMode.edit && (
                    <div className="row">
                      <div className="col-md-4">
                        <InputField
                          label={"Nama Dusun"}
                          placeholder="Masukkan Nama Dusun"
                          name="sub_village"
                          onChange={this.handleInputChange}
                          value={this.state.sub_village.value}
                          isRequired={true}
                          hasError={!this.state.sub_village.isValid}
                          errorMessage={this.state.sub_village.message}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputField
                          label={"Jumlah Penduduk Dusun"}
                          placeholder="Masukkan Nama Dusun"
                          name="total_population_sub_village"
                          onChange={this.handleInputChange}
                          value={this.state.total_population_sub_village.value}
                          isRequired={true}
                          hasError={
                            !this.state.total_population_sub_village.isValid
                          }
                          errorMessage={
                            this.state.total_population_sub_village.message
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <InputField
                          label={"Jumlah Kelambu Terdistribusi"}
                          placeholder="Masukkan Nama Dusun"
                          name="total_net_distribution_sub_village"
                          onChange={this.handleInputChange}
                          value={
                            this.state.total_net_distribution_sub_village.value
                          }
                          isRequired={true}
                          hasError={
                            !this.state.total_net_distribution_sub_village
                              .isValid
                          }
                          errorMessage={
                            this.state.total_net_distribution_sub_village
                              .message
                          }
                        />
                      </div>
                    </div>
                  )}
              </>
            )}

            {showAnyDusunFlag && this.props.mode === "add" && (
              <InputField
                label={"Jumlah Dusun"}
                type="numberOnly"
                placeholder="0"
                name="total_sub_villages"
                onChange={this.handleInputChange}
                value={this.state.total_sub_villages.value}
                isRequired={true}
                hasError={!this.state.total_sub_villages.isValid}
                errorMessage={this.state.total_sub_villages.message}
              />
            )}

            {/* TABEL: KELAMBU */}
            {this.state.is_dusun_level_distribution.value === "Ya" &&
              this.props.mode === PageMode.add && (
                <div className="mt-3">
                  <h5>Detail Distribusi Kelambu per Dusun</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ minWidth: 200 }}>Nama Dusun</th>
                          <th style={{ minWidth: 200 }}>
                            Jumlah Penduduk Dusun
                          </th>
                          <th style={{ minWidth: 220 }}>
                            Jumlah Kelambu Terdistribusi
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.hamlets_distribution.value.map(
                          (row, idx) => (
                            <tr key={`kelambu-hamlet-${idx}`}>
                              <td>
                                <InputField
                                  name={`kelambu_nama_dusun_${idx}`}
                                  type="text"
                                  placeholder="Nama Dusun..."
                                  onChange={(e) =>
                                    this.handleHamletDistributionChange(
                                      idx,
                                      "nama_dusun",
                                      e.target.value,
                                    )
                                  }
                                  value={row.nama_dusun}
                                />
                              </td>
                              <td>
                                <InputField
                                  name={`kelambu_jumlah_penduduk_${idx}`}
                                  type="numberOnly"
                                  placeholder="0"
                                  onChange={(e) =>
                                    this.handleHamletDistributionChange(
                                      idx,
                                      "jumlah_penduduk_dusun",
                                      e.target.value,
                                    )
                                  }
                                  value={row.jumlah_penduduk_dusun}
                                />
                              </td>
                              <td>
                                <InputField
                                  name={`kelambu_jumlah_terdistribusi_${idx}`}
                                  type="numberOnly"
                                  placeholder="0"
                                  onChange={(e) =>
                                    this.handleHamletDistributionChange(
                                      idx,
                                      "jumlah_kelambu_terdistribusi_tingkat_dusun",
                                      e.target.value,
                                    )
                                  }
                                  value={
                                    row.jumlah_kelambu_terdistribusi_tingkat_dusun
                                  }
                                />
                              </td>
                            </tr>
                          ),
                        )}
                        {this.state.hamlets_distribution.value.length === 0 && (
                          <tr>
                            <td colSpan={3} className="text-center text-muted">
                              Isi Jumlah Dusun untuk men-generate baris
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

            {/* TABEL: IRS */}
            {this.state.is_dusun_level_intervention.value === "Ya" &&
              this.props.mode === PageMode.add && (
                <div className="mt-3">
                  <h5>Detail IRS per Dusun</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ minWidth: 200 }}>Nama Dusun</th>
                          <th style={{ minWidth: 200 }}>
                            Jumlah Penduduk Dusun
                          </th>
                          <th style={{ minWidth: 260 }}>
                            Jumlah Total Sasaran Rumah (Tingkat Dusun)
                          </th>
                          <th style={{ minWidth: 280 }}>
                            Jumlah Total Rumah yang Disemprot (Tingkat Dusun)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.hamlets_irs.value.map((row, idx) => (
                          <tr key={`irs-hamlet-${idx}`}>
                            <td>
                              <InputField
                                name={`irs_nama_dusun_${idx}`}
                                type="text"
                                placeholder="Nama Dusun..."
                                onChange={(e) =>
                                  this.handleHamletIRSChange(
                                    idx,
                                    "nama_dusun",
                                    e.target.value,
                                  )
                                }
                                value={row.nama_dusun}
                              />
                            </td>
                            <td>
                              <InputField
                                name={`irs_jumlah_penduduk_${idx}`}
                                type="numberOnly"
                                placeholder="0"
                                onChange={(e) =>
                                  this.handleHamletIRSChange(
                                    idx,
                                    "jumlah_penduduk_dusun",
                                    e.target.value,
                                  )
                                }
                                value={row.jumlah_penduduk_dusun}
                              />
                            </td>
                            <td>
                              <InputField
                                name={`irs_sasaran_rumah_${idx}`}
                                type="numberOnly"
                                placeholder="0"
                                onChange={(e) =>
                                  this.handleHamletIRSChange(
                                    idx,
                                    "jumlah_total_sasaran_rumah_tingkat_dusun",
                                    e.target.value,
                                  )
                                }
                                value={
                                  row.jumlah_total_sasaran_rumah_tingkat_dusun
                                }
                              />
                            </td>
                            <td>
                              <InputField
                                name={`irs_rumah_disemprot_${idx}`}
                                type="numberOnly"
                                placeholder="0"
                                onChange={(e) =>
                                  this.handleHamletIRSChange(
                                    idx,
                                    "jumlah_total_rumah_yang_disemprot_tingkat_dusun",
                                    e.target.value,
                                  )
                                }
                                value={
                                  row.jumlah_total_rumah_yang_disemprot_tingkat_dusun
                                }
                              />
                            </td>
                          </tr>
                        ))}
                        {this.state.hamlets_irs.value.length === 0 && (
                          <tr>
                            <td colSpan={4} className="text-center text-muted">
                              Isi Jumlah Dusun untuk men-generate baris
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

            <div className="form-group d-flex justify-content-end">
              <Button onClick={() => this.props.changeMode("view")} isSecondary>
                Batalkan
              </Button>
              <Button
                onClick={this.onSave}
                isPrimary
                isLoading={this.state.isLoading}
              >
                Simpan Data
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
